import { settingsSchema } from './chunk-GU4P4QPI.mjs';
import { selectCurrentTimeZone } from './chunk-PHOCK55S.mjs';
import mapValues from 'lodash/mapValues';
import * as yup from 'yup';

var specialSchema = (state) => yup.object().shape({
  name: yup.string().trim().required("nameRequired"),
  menuTypeVersions: yup.lazy(
    (obj) => yup.object(
      mapValues(
        obj,
        () => yup.object({
          posName: yup.string().trim().required("posNameRequired"),
          checkName: yup.string().trim().required("checkNameRequired"),
          buyQuantity: yup.number().integer().when("specialApplyTo", {
            is: "bogo" /* BOGO */,
            then: (schema) => schema.min(1, "specials.buyQuantityRequired"),
            otherwise: (schema) => schema.notRequired()
          }),
          getQuantity: yup.number().integer().when("specialApplyTo", {
            is: "bogo" /* BOGO */,
            then: (schema) => schema.min(1, "specials.getQuantityRequired"),
            otherwise: (schema) => schema.notRequired()
          }),
          availableTimes: settingsSchema(
            () => "availabilityError",
            selectCurrentTimeZone(state)
          )
        })
      )
    )
  )
});

export { specialSchema };
